
// Inicializa primeiro o slider de thumbnails
const mediaGalleryThumbs = new Swiper('.slider-component-thumbs', {
  slidesPerView: 3,
  spaceBetween: 8,
  watchSlidesProgress: true,

  navigation: {
    nextEl: '.slider-component-thumbs__wrapper .swiper-next',
    prevEl: '.slider-component-thumbs__wrapper .swiper-prev',
  }
});

// Inicializa o slider principal com referência ao de thumbnails
const mediaGalleryDesktop = new Swiper('.slider-component', {
  slidesPerView: 1,
  spaceBetween: 6,
  
  breakpoints: {
    768: {
      slidesPerView: 'auto',
      spaceBetween: 8,
    },
    1280: {
      slidesPerView: 1
    }
  },

  navigation: {
    nextEl: '.slider-component .swiper-next',
    prevEl: '.slider-component .swiper-prev',
  },

  pagination: {
    el: ".slider-component .swiper-pagination",
    type: "fraction",
  },

  // Conecta com o slider de thumbnails
  thumbs: {
    swiper: mediaGalleryThumbs,
  },
});